export default __webpack_public_path__ + "static/media/body-banner.6b457fe5.jpg";